declare namespace $ {

	export class $mol_icon_github extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=github.view.tree.d.ts.map